import { InjectionToken } from "@angular/core";

export const ZHH_REALITY_CHECK_SERVICE = new InjectionToken("ZHH_REALITY_CHECK_SERVICE");
